var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.isButton ? 'button' : 'fdk-link',_vm._b({tag:"component",class:_vm.mergedClasses,attrs:{"link":_vm.isButton ? undefined : _vm.href,"target":_vm.isButton ? undefined : '_blank',"disabled":_vm.isDisabled},on:{"click":_vm.handleClick}},'component',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }